

	import { Vue, Component } from "vue-property-decorator";
	import { Header } from "element-ui";
	// @Component({
	//   name: "brandDetail",
	// })
	export default {
		
		data(){
			return{
				tableData:{},
				imageData:[]
			};
		},
		mounted() {
				
			let paramter = {
					id:this.$route.query.cid,
			};
			this.$http.get("brand/"+this.$route.query.cid,{params:paramter}).then((res: any) =>{
				
				this.tableData = res.data.data;
				this.imageData.push(this.tableData.logo); 
			});
			
		},
		created(){
			
			console.log(this.$route.query);
		},
		methods: {
			
			getAssessList(){
				console.log(this.$route.query);
			},
			onCancel(){
				// 取消
				this.$router.back();
			},
			checkError(){
				// 不通过
				let reason = "不通过";
				let result = 0;
				let brandId = this.tableData.id;
				
				let paramter = {
					'brandId': brandId,
					'reason':reason,
					'result':result,
					'type':1,
				};
				this.$http.post("brand/check",{params:paramter}).then((res: any) =>{
					
					let code = res.data.code;
					let msg = res.data.msg;
					if(code == 200) {
						window.location.reload();
						this.$message({
						    message: msg,
						    type: 'success'
						});
						// this.$router.back();
					}
				});
			},
			checkSuccess(){
				// 通过
				let reason = "通过";
				let result = 1;
				let brandId = this.tableData.id;
				
				let paramter = {
					'brandId': brandId,
					'reason':reason,
					'result':result,
					'type':1,
				};
				this.$http.post("brand/check",paramter).then((res: any) =>{
					
					let code = res.data.code;
					let msg = res.data.msg;
					if(code == 200) {
						// window.location.reload();
						this.$message({
						    message: msg,
						    type: 'success'
						});
						// this.$router.back();
					}
				});
			},

			
		},
		
	}
